import './resourceExplorer.css';
import { ResourceList, ResourceText, ResourceDetails } from '../../componentsIndex';
import { ShowContext } from '../../../context/Context';
import { useContext, useState } from 'react';
import { useEffect } from 'react';


const ResourceExplorer = () => {
  const ctx = useContext(ShowContext);
  const [resource, setSelectedResource] = useState("");
  const [resourceListData, setResourceListData] = useState("");

  useEffect(() => {
   setResourceListData("")
  }, [resource])
  
  function extractResourceData(){
    return ctx.wholeData?.find((item) => (
      item.resourceType === resource
    ))
  }
  return (
    <div className="resourceContainer">
      <div className='resourceList'>
        <p style={{ 'fontSize': '18px' }}>Resource Types</p>
        <ResourceList data={ctx.wholeData} resource={resource} setSelectedResource={setSelectedResource} />
      </div>
      {resource && <div className='resourcesText'>
        <p style={{ 'fontSize': '18px', 'marginLeft': '5%' }}>{resource} resources</p>
        <ResourceText selectedResource = {resource} resourceListData={resourceListData} extractResourceData = {extractResourceData} setResourceListData={setResourceListData} />
      </div>}
      {resourceListData && <div className="resourcesDetails">
        <p style={{ 'fontSize': '18px' }}>Resource Details</p>
        <ResourceDetails resourceListData = {resourceListData} />
      </div>}
    </div>
  );
}
export default ResourceExplorer;